import React from 'react'
import OnlyTitleNav from '../OnlyTitleNav'

const NotFound = () => (
  <div>
    <OnlyTitleNav title="BOOK ME INSTEAD. NotFound Page" />
    <div>
      404 NotFound
    </div>
  </div>
)

export default NotFound